import { gql } from "@apollo/client";

export const DELETE_EDITION_AND_EVERYTHING= gql(`mutation deleteEditionAndEverything($editionId: String!) {
  deleteEditionAndAllBookingsAndBands (editionId: $editionId)
}`)

export const DELETE_EDITION_BOOKINGS= gql(`mutation deleteAllBookingsForEdition($editionId: String!) {
  deleteAllBookingsForEdition (editionId: $editionId)
}`)

export const IMPORT_CLASHFINDER_EDITION = gql(`mutation importClashfinder($url: String!) {
  importClashfinder(url: $url)
}`)